import { useConfiguration } from '@travel-frontend/core';
import { useCallback } from 'react';
export const useGenerateLink = () => {
  const getTargetPath = useCallback((path, addCurrentPath, currentPath) => {
    if (addCurrentPath) {
      return path.endsWith('/') ? `${path.replace(/\/$/, '')}${currentPath}` : `${path}${currentPath}`;
    }
    return path;
  }, []);
  const origin = useConfiguration('origin');
  const generateLink = useCallback((path, currentPath, addCurrentPath = false) => {
    const targetPath = getTargetPath(path, addCurrentPath, currentPath);
    return `${targetPath.startsWith('http') ? targetPath : `${origin}/${targetPath}`}`;
  }, [getTargetPath, origin]);
  return {
    generateLink
  };
};